/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Small timeout to ensure inner elements are rendered
      setTimeout(() => {
        this.links = this.querySelectorAll('.social:not(.clipboard):not(.whatsapp)');
        this.clipboard = this.querySelector('.social.clipboard');
        
        if (this.clipboard) {
          this.clipboard.addEventListener('click', this.onClipboardClick.bind(this));
        } else {
          console.warn('SocialShare: Clipboard element not found.');
        }
        
        this.setupEventListeners();
      }, 50);
    }
    onClipboardClick() {
      const url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.showGlobalToast('Copied to clipboard');
        }).catch(err => {
          console.error('Failed to copy: ', err);
          this.fallbackCopy(url);
        });
      } else {
        this.fallbackCopy(url);
      }
    }

    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showGlobalToast('Copied to clipboard');
    }

    showGlobalToast(message) {
      let toast = document.querySelector('.share-toast-global');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'share-toast-global';
        document.body.appendChild(toast);
      }
      
      toast.textContent = message;
      toast.classList.add('is-visible');
      
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2500);
    }
    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
          event.preventDefault();
        });
      });
    }
  }
  customElements.define('social-share', SocialShare);
}